export const Roles = {
  ROLE_USER: 'ROLE_USER',
  ROLE_SUPER: 'ROLE_SUPER',
  ROLE_DENTAL: 'ROLE_DENTAL',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_SPED: 'ROLE_SPED'

}

